// extracted by mini-css-extract-plugin
export default {"head":"ContactUs_head__6-gLB"};